/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FeatureUsageDto,
    FeatureUsageDtoFromJSON,
    FeatureUsageDtoFromJSONTyped,
    FeatureUsageDtoToJSON,
} from './FeatureUsageDto';
import {
    MultiplePortfoliosDto,
    MultiplePortfoliosDtoFromJSON,
    MultiplePortfoliosDtoFromJSONTyped,
    MultiplePortfoliosDtoToJSON,
} from './MultiplePortfoliosDto';
import {
    PersonalAssetTypeUsageDto,
    PersonalAssetTypeUsageDtoFromJSON,
    PersonalAssetTypeUsageDtoFromJSONTyped,
    PersonalAssetTypeUsageDtoToJSON,
} from './PersonalAssetTypeUsageDto';
import {
    PortfolioSharingDto,
    PortfolioSharingDtoFromJSON,
    PortfolioSharingDtoFromJSONTyped,
    PortfolioSharingDtoToJSON,
} from './PortfolioSharingDto';
import {
    PriceAlertsUsageDto,
    PriceAlertsUsageDtoFromJSON,
    PriceAlertsUsageDtoFromJSONTyped,
    PriceAlertsUsageDtoToJSON,
} from './PriceAlertsUsageDto';
import {
    WatchlistAdoptionDto,
    WatchlistAdoptionDtoFromJSON,
    WatchlistAdoptionDtoFromJSONTyped,
    WatchlistAdoptionDtoToJSON,
} from './WatchlistAdoptionDto';

/**
 * 
 * @export
 * @interface AdminFeatureAdoptionDto
 */
export interface AdminFeatureAdoptionDto {
    /**
     * Total number of users for percentage calculation
     * @type {number}
     * @memberof AdminFeatureAdoptionDto
     */
    totalUsers: number;
    /**
     * Investown integration usage
     * @type {FeatureUsageDto}
     * @memberof AdminFeatureAdoptionDto
     */
    investown: FeatureUsageDto | null;
    /**
     * Personal finance (personal assets) usage
     * @type {FeatureUsageDto}
     * @memberof AdminFeatureAdoptionDto
     */
    personalFinance: FeatureUsageDto | null;
    /**
     * Manual trades usage
     * @type {FeatureUsageDto}
     * @memberof AdminFeatureAdoptionDto
     */
    manualTrades: FeatureUsageDto | null;
    /**
     * Trading212 API integration usage
     * @type {FeatureUsageDto}
     * @memberof AdminFeatureAdoptionDto
     */
    trading212Api: FeatureUsageDto | null;
    /**
     * Multiple portfolios usage
     * @type {MultiplePortfoliosDto}
     * @memberof AdminFeatureAdoptionDto
     */
    multiplePortfolios: MultiplePortfoliosDto | null;
    /**
     * Personal asset types breakdown
     * @type {Array<PersonalAssetTypeUsageDto>}
     * @memberof AdminFeatureAdoptionDto
     */
    personalAssetTypes: Array<PersonalAssetTypeUsageDto>;
    /**
     * Watchlist adoption metrics
     * @type {WatchlistAdoptionDto}
     * @memberof AdminFeatureAdoptionDto
     */
    watchlistAdoption: WatchlistAdoptionDto | null;
    /**
     * Price alerts usage metrics
     * @type {PriceAlertsUsageDto}
     * @memberof AdminFeatureAdoptionDto
     */
    priceAlertsUsage: PriceAlertsUsageDto | null;
    /**
     * Portfolio sharing statistics
     * @type {PortfolioSharingDto}
     * @memberof AdminFeatureAdoptionDto
     */
    portfolioSharing: PortfolioSharingDto | null;
}

export function AdminFeatureAdoptionDtoFromJSON(json: any): AdminFeatureAdoptionDto {
    return AdminFeatureAdoptionDtoFromJSONTyped(json, false);
}

export function AdminFeatureAdoptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminFeatureAdoptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalUsers': json['totalUsers'],
        'investown': FeatureUsageDtoFromJSON(json['investown']),
        'personalFinance': FeatureUsageDtoFromJSON(json['personalFinance']),
        'manualTrades': FeatureUsageDtoFromJSON(json['manualTrades']),
        'trading212Api': FeatureUsageDtoFromJSON(json['trading212Api']),
        'multiplePortfolios': MultiplePortfoliosDtoFromJSON(json['multiplePortfolios']),
        'personalAssetTypes': ((json['personalAssetTypes'] as Array<any>).map(PersonalAssetTypeUsageDtoFromJSON)),
        'watchlistAdoption': WatchlistAdoptionDtoFromJSON(json['watchlistAdoption']),
        'priceAlertsUsage': PriceAlertsUsageDtoFromJSON(json['priceAlertsUsage']),
        'portfolioSharing': PortfolioSharingDtoFromJSON(json['portfolioSharing']),
    };
}

export function AdminFeatureAdoptionDtoToJSON(value?: AdminFeatureAdoptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalUsers': value.totalUsers,
        'investown': FeatureUsageDtoToJSON(value.investown),
        'personalFinance': FeatureUsageDtoToJSON(value.personalFinance),
        'manualTrades': FeatureUsageDtoToJSON(value.manualTrades),
        'trading212Api': FeatureUsageDtoToJSON(value.trading212Api),
        'multiplePortfolios': MultiplePortfoliosDtoToJSON(value.multiplePortfolios),
        'personalAssetTypes': ((value.personalAssetTypes as Array<any>).map(PersonalAssetTypeUsageDtoToJSON)),
        'watchlistAdoption': WatchlistAdoptionDtoToJSON(value.watchlistAdoption),
        'priceAlertsUsage': PriceAlertsUsageDtoToJSON(value.priceAlertsUsage),
        'portfolioSharing': PortfolioSharingDtoToJSON(value.portfolioSharing),
    };
}

